<template>
    <div class="w-auto app-fixed-height flex flex-col" v-if="renderComponent">
        <div class="vs-con-loading__container absolute h-full w-full z-max" v-show="loading" id="loading"></div>
        <div class="flex items-center justify-between w-full h-16">
            <vs-button class="hidden lg:block" @click="forceRerender" v-if="orderStatus === 'proccessed'">Vender Novo Item</vs-button>
            <vs-button class="hidden lg:block" @click="() => addItem({})" v-else>Novo Item</vs-button>
            <span class="" v-if="true">Venda para: <font  class="text-primary">{{customer.fantasy_name}}</font></span>
            <vs-button class="lg:hidden" icon-pack="feather" icon="icon-plus-square" @click="forceRerender" v-if="orderStatus === 'proccessed'"></vs-button>
            <vs-button class="lg:hidden" icon-pack="feather" icon="icon-shopping-bag" @click="showCheckoutMobile"></vs-button>
        </div>
        <div class="flex h-full">
            <Cart ref="cart" @change="updateCartItems" class="w-full h-full lg:w-2/3 lg:mr-8 lg:rounded" v-show="!isMobile || isMobile && !isCheckoutActive" :status="orderStatus" :items="items" :class="{'hide-cart': isCheckoutActive && isMobile}"></Cart>
            <Checkout @status="changeStatus" :customer="customerId" :items="itemsCart" class="lg:w-1/3 lg:h-128 lg:rounded relative h-full w-full" v-show="isCheckoutActive" :status="orderStatus" :class="{'hide-cart': !isCheckoutActive, ' animation-open': isMobile}"></Checkout>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        Cart: () => import("./Components/Cart/Cart"),
        Checkout: () =>  import("./Components/Checkout/Checkout")
    },

    data () {
        return {
            isMobile: false,
            isCheckoutActive: true,
            items: [],
            orderStatus: 'created',
            itemsCart: [],
            customer: {},
            customerId: 0,
            loading: true,
            renderComponent: true,
        }
    },

    methods: {
        forceRerender() {
            // Remove my-component from the DOM
            this.isMobile = false;
            this.isCheckoutActive = true;
            this.orderStatus = 'created';
            this.itemsCart = [];
            this.renderComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderComponent = true;
            });
        },
        changeStatus (value) {
            this.orderStatus = value;
        },

        updateCartItems(items) {
            this.itemsCart = items.filter(item => item.packageId);
        },

        showCheckoutMobile() {
            this.isCheckoutActive = !this.isCheckoutActive;
        },

        resize (target) {
            if (target.innerWidth > 800) {
                this.isMobile = false;
                this.isCheckoutActive = true;
            } else {
                this.isMobile = true;
                this.isCheckoutActive = false;
            }
        },

        async loadItems () {
            const {data} = await this.$axios("store/items");
            this.items = data.map((item) => ({
                name: item.nome,
                systemId: item.id_item_grupo,
                packages: item.items.map((packageItem) => (
                    {
                        name: packageItem.nome, packageId: packageItem.id_item, price: packageItem.valor, maxDiscount: packageItem.valor_desconto_maximo_permitido,
                        hasRecurring:packageItem.gera_recorrencia
                    }))
            }))
        },
        addItem (item = null) {
            this.$refs.cart.addItem(item);
        },

        async loadOrderItems(orderId) {
            const {data} = await this.$axios.get(`/store/order/${orderId}`);
            data.items.map(item =>
                ({name: item.nome, price: item.valor, priceGiven: item.valor_final, discount: item.desconto, systemId: item.id_item_grupo, packageId: item.id_item, receivedInHands: item.recebido_em_maos})
            ).forEach(item => this.addItem(item));
            this.orderStatus = 'proccessed';
        },

        async loadCustomer(customerId, customer = null)
        {
            if (customer) {
                this.customer = customer;
            } else {
                const {data: {data}} = await this.$axios(`company/${customerId}`);
                this.customer = data.company;
            }

            this.customerId = this.customer.id_company;
        }
    },
    mounted () {
        this.$vs.loading({
            type: 'default',
            scale: '0.5',
            container: '#loading'
        });
    },

    async created () {
        await this.loadCustomer(this.$route.params.customerId, this.$route.params.customer);
        await this.loadItems();
        if (this.$route.params.order_id) {
            this.loadOrderItems(this.$route.params.order_id)
        }

        this.resize(window);
        window.addEventListener('resize', ({currentTarget}) => {
            this.resize(currentTarget);
        });

        this.loading = false;
    }
}
</script>

<style scoped>
    @keyframes open {
        from {
            margin-top: 100%;
        }

        to {
            margin-top: 0%;
        }
    }

    .animation-open {
        will-change: transform;
        animation-name: open;
        animation-duration: 0.7s;
    }

    .hide-cart {
        display: none !important;
    }
</style>
